import styled from "styled-components";

export const TacticsWrapper = styled.div`
  form {
    margin-top: 38px;
  }
  .ant-form-item-label label {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    color: #1c1c1c;
  }
  .ant-select-selector {
    border-radius: 8px;
    border: 1px solid #eaeaea !important;
    background: #fafafa !important;
    height: 56px !important;
  }
  .ant-select-arrow {
    height: 100%
  }
  .multi {
    .ant-select-arrow {
      height: auto
    }
  }

  .brand-select .ant-select-selector .ant-select-selection-item,
  .ant-select-selector .ant-select-selection-placeholder {
    line-height: 53px !important;
  }
  .ant-select-selector .ant-select-selection-item,
  .ant-select-selector .ant-select-selection-placeholder {
    font-family: "PoppinsRegular", sans-serif !important;
  }
  .ant-picker {
    height: 48px;
    border: 1px solid #eaeaea;
    background: #fafafa;
  }

  .large {
    font-size: 18px;
  }

  .range {
    width: 100%;
    height: 54px;
  }

  .radio {
    margin-top: 7px;
  }

  .tactics-form-item {
    display: flex;
    align-items: center;
    margin-top: 1em;
  }

  .tactics-form-item-label {
    margin-right: 0.5em;
    margin-left: 0.5em;
    font-size: 1.5em;
  }

  .tactics-form-cell-select {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .ant-select-selector {
    height: 32px !important;
    width: 100%;
  }

  .ant-select-arrow {
    margin-top: -16px;
  }

  .tactics-title {
    display: flex;
  }

  .tactics-title-select {
    margin-left: 2em;
    margin-top: -.25em;
    margin-bottom: -.25em;
    width: 10em;
  }

  .ant-input[disabled] {
    color: #555555;
  }
`;
